import React, { useEffect, useState } from 'react'
import { isEmpty, get } from 'lodash'

export default function useListFilter(cached = [], fetching, companyAtr = ['company']) {
  const [company, setCompany] = React.useState()
  const [list, setList] = React.useState(() => cached)

  function onChangeCompany(company) {
    if (isEmpty(company)) {
      setList(cached)
      setCompany(company)
    } else {
      const finalList = cached.filter(i => {
        const d = companyAtr.map(attr => get(i, attr + '._id'))
        return d.includes(company)
      })
      setList(finalList)
      setCompany(company)
    }
  }

  React.useEffect(() => {
    if (!company) setList(cached)
    else onChangeCompany(company)
  }, [fetching])

  return { list, company, onChangeCompany, setList, setCompany }
}
